import { restClient } from '@/Core'

import { NOTIFICATIONS_URL } from '../Helpers/notificationApi'
import { NotificationStore } from '../Stores/NotificationStore'
import { LoadUnreadCountTask } from './LoadUnreadCountTask'

/**
 * Позначити сповіщення прочитаними.
 *
 * Список і лічильник міняються одразу, сервер — слідом. Якщо сервер щось
 * відхилив, лічильник перечитується, щоб не брехати.
 */
export const MarkNotificationsReadTask = async (uuids: string[]): Promise<void> => {
    if (uuids.length === 0) return

    NotificationStore.markRead(uuids)

    const results = await Promise.allSettled(
        uuids.map((uuid) => restClient.patch(`${NOTIFICATIONS_URL}/${uuid}/change_is_readed`))
    )

    if (results.some((result) => result.status === 'rejected')) {
        await LoadUnreadCountTask()
    }
}
